import cronstrue from 'cronstrue';
import i18n from "../i18n";
import 'cronstrue/locales/pl';
import 'cronstrue/locales/en';

export const translateCronToHumanReadable = (cronExpression: string): string => {
    const lang = (i18n.language || 'pl').split('-')[0];

    try {
        return cronstrue.toString(cronExpression, {
            locale: lang,
            use24HourTimeFormat: true,
        });
    } catch {
        return i18n.t('cronConfig.validation.invalidExpression');
    }
};

export const validateStepExpression = (
    value: string,
    min: number,
    max: number
): string => {
    const [rangePart, stepPart] = value.split('/');
    const rangeSize = max - min + 1;

    // walidacja kroku
    if (!/^\d+$/.test(stepPart)) {
        return i18n.t('cronConfig.validation.stepMustBeInteger');
    }

    const step = parseInt(stepPart, 10);

    if (step === 0) {
        return i18n.t('cronConfig.validation.stepCannotBeZero');
    }

    if (step >= rangeSize) {
        return i18n.t('cronConfig.validation.stepExceedsRange', {step, rangeSize});
    }

    // walidacja części przed "/"
    if (rangePart === '*') {
        return ''; // */5 – zawsze poprawne jeśli krok ok
    }

    // format: "start" np. "5/10"
    if (/^\d+$/.test(rangePart)) {
        const start = parseInt(rangePart, 10);

        if (start < min || start > max) {
            return i18n.t('cronConfig.validation.startValueBetween', {start, min, max});
        }

        const remainingRange = max - start + 1;
        if (step >= remainingRange) {
            return i18n.t('cronConfig.validation.stepExceedsRemainingRange', {step, start, max, remaining: remainingRange});
        }

        return '';
    }

    // format: "start-end" np. "0-30/5"
    if (/^\d+-\d+$/.test(rangePart)) {
        const [fromStr, toStr] = rangePart.split('-');
        const from = parseInt(fromStr, 10);
        const to = parseInt(toStr, 10);

        if (from < min || from > max) {
            return i18n.t('cronConfig.validation.rangeStartBetween', {from, min, max});
        }

        if (to < min || to > max) {
            return i18n.t('cronConfig.validation.rangeEndBetween', {to, min, max});
        }

        if (from > to) {
            return i18n.t('cronConfig.validation.rangeStartGreaterThanEnd', {from, to});
        }

        const subRangeSize = to - from + 1;
        if (step >= subRangeSize) {
            return i18n.t('cronConfig.validation.stepExceedsSubRange', {step, from, to, subRangeSize});
        }

        return '';
    }

    return i18n.t('cronConfig.validation.invalidFormatBeforeSlash');
};

export const validateCronField = (value: string, min: number, max: number): string => {
    const trimmedValue = value.trim();

    if (trimmedValue === '?' || trimmedValue === '*')
        return '';

    if (/^\d+$/.test(trimmedValue)) {
        const num = parseInt(trimmedValue, 10);

        if (num < min || num > max)
            return i18n.t('cronConfig.validation.valueBetween', {min, max});
        return '';
    }

    if (trimmedValue.includes('/')) {
        return validateStepExpression(trimmedValue, min, max);
    }

    if (/^\d+-\d+$/.test(trimmedValue)) {
        const [from, to] = trimmedValue.split('-').map(Number);

        if (from < min || to > max || from > to)
            return i18n.t('cronConfig.validation.rangeBeyond', {min, max});
        return '';
    }

    if (/^[\d,]+$/.test(trimmedValue)) {
        const nums = trimmedValue.split(',').map(Number);

        if (nums.some(n => n < min || n > max))
            return i18n.t('cronConfig.validation.listBetween', {min, max});
        return '';
    }

    return i18n.t('cronConfig.validation.invalidFormat');
};